(() => {
    if (!customElements.get("collection-menu")) {
      class CollectionMenu extends HTMLElement {
        constructor() {
          super();
          this.accordions = this.querySelectorAll('.collection-sidebar__category');
          this.parentCollectionName = this.dataset.parent;
        }
  
        connectedCallback() {
          // this.checkActiveCollection();
          this.bindEvents();
        }
  
        checkActiveCollection() {
          if (!this.parentCollectionName) return;
          const parentName = this.parentCollectionName.toLowerCase().trim();
          this.accordions.forEach(acc => {
              const accName = acc.dataset.name;
              const content = acc.querySelector('.collection-sidebar__category-content');
              if (accName?.toLowerCase().trim() === parentName ){
                  this.openAccordion(acc, content);
              }
          })
        }
        handleAccordionClick(e) {
          const currentAccordion = e.currentTarget;
          const currentContent = currentAccordion.querySelector('.collection-sidebar__category-content');
          const isToggleElement = e.target.closest('.collection-sidebar__category-button');
  
          if (!isToggleElement || !currentContent) return;
    
          if (currentAccordion.classList.contains('active')){
              this.closeAccordion(currentAccordion, currentContent);
              return;
          } 
  
          this.closeAllAccordions(currentAccordion);
          this.openAccordion(currentAccordion, currentContent);
  
          currentContent.addEventListener('transitionend', function handler(e) {
            if (currentAccordion.classList.contains('active')) {
              currentContent.style.maxHeight = 'none';
            }
            currentContent.removeEventListener('transitionend', handler);
          });
         
        }
  
        openAccordion(accordion, content) {
          accordion.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
  
        closeAccordion(accordion, content) {
          accordion.classList.toggle('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
              content.style.maxHeight = '0px';
          });
        }
  
        closeAllAccordions(currentAccordion) {
          this.accordions.forEach(acc => {
            const content = acc.querySelector('.collection-sidebar__category-content');
            if (acc !== currentAccordion) {
              acc.classList.remove('active');
              if (content) {
                content.style.maxHeight = content.scrollHeight + 'px';
                requestAnimationFrame(() => {
                  content.style.maxHeight = '0px';
                });
              }
            }
          });
        }
  
        bindEvents() {
          this.accordions.forEach(accordion => accordion.addEventListener("click", (e) => this.handleAccordionClick(e)))
        }
      }
  
      customElements.define("collection-menu", CollectionMenu);
    }
  })();
  